"use client";
import { useFirstInteraction } from "@/lib/useFirstInteraction";
import { PageviewTracker } from "./PageviewTracker";
import { ScrollDepthTracker } from "./ScrollDepthTracker";
import { EngagementTimeTracker } from "./EngagementTimeTracker";
import { VisibilityTracker } from "./VisibilityTracker";
import { ClickDelegator } from "./ClickDelegator";
import { WebVitalsTracker } from "./WebVitalsTracker";
import { ErrorTracker } from "./ErrorTracker";

// All auto-tracking is gated behind first interaction. Bounce visitors and
// synthetic loads (Lighthouse, crawlers) never run any of these, which is
// the same tradeoff GtmScript/AdSenseScript make: keep the BP score clean
// at the cost of missing data on non-engaged visits. See
// lib/useFirstInteraction.ts for the rationale.
export function AnalyticsAutopilot() {
  const ready = useFirstInteraction();
  if (!ready) return null;
  return (
    <>
      <PageviewTracker />
      <ScrollDepthTracker />
      <EngagementTimeTracker />
      <VisibilityTracker />
      <ClickDelegator />
      <WebVitalsTracker />
      <ErrorTracker />
    </>
  );
}
